import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c3b6d95a&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3b6d95a')) {
      api.createRecord('c3b6d95a', component.options)
    } else {
      api.reload('c3b6d95a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c3b6d95a&lang=pug", function () {
      api.rerender('c3b6d95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/youtubeModal/index.vue"
export default component.exports